import { DocumentListService } from '@alfresco/adf-content-services';
import { PaginationModel } from '@alfresco/adf-core';
import { NodeEntry, NodePaging } from '@alfresco/js-api';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class WkDocumentListService {
  pagination: PaginationModel;
  constructor(private readonly documentListService: DocumentListService) {}

  preservePaginationState(holdPagination: PaginationModel) {
    this.pagination = holdPagination;
  }

  destroyPaginationState() {
    this.pagination = null;
  }

  isCustomSourceService(nodeId: any) {
    return this.documentListService.isCustomSourceService(nodeId);
  }

  getFolderNode(
    nodeId: string,
    includeFields: string[] = []
  ): Observable<NodeEntry> {
    return this.documentListService.getFolderNode(nodeId, includeFields);
  }

  getFolder(
    folder: string,
    opts = null,
    includeFields: string[] = []
  ): Observable<NodePaging> {
    return this.documentListService.getFolder(folder, opts, includeFields);
  }

  loadFolderByNodeId(
    nodeId: any,
    pagination: any,
    includeFields: string[],
    where?: string,
    orderBy?: string[]
  ) {
    return this.documentListService.loadFolderByNodeId(
      nodeId,
      pagination,
      includeFields,
      where,
      orderBy
    );
  }

  isReloaded(): Observable<any> {
    return this.documentListService.reload$;
  }
}
